module.exports = __webpack_public_path__ + "assets/img/6_605_big.839d2c33.jpg";